import { Box, Grid, makeStyles, Theme } from "@material-ui/core";
import React, { useContext, useEffect, useMemo } from "react";
import { isSafari } from "react-device-detect";
import { animated, useSpring } from "react-spring";
import { FavoritesIcon } from "../../assets/icons/favorites-icon";
import { MenuCategoryDictionary, MenuSubcategoryDictionary } from "../../models/categories";
import { MenuItemCategory, MenuItemSubcategory } from "../../models/types/category-types";
import { theme } from "../../theme/theme";
import { AnswerSection } from "./answer/answer-section";
import { AnswerContext } from "./answer/context/answer-context";
import { BorderSectionWrapper } from "./border-section-wrapper";

const useStyles = makeStyles((theme: Theme) => ({
  mainSection: {
    position: "relative",
  },
  mainSectionItem: {
    maxWidth: "100%",
  },
  favourite: {
    position: "absolute",
    top: isSafari ? 79 : 54,
    right: 60,
    width: 20,
    height: 20,
    padding: theme.spacing(4),
    paddingTop: theme.spacing(3),
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    cursor: "pointer",
    zIndex: 100,
    transition: "background-color 0.3s ease",
    [theme.breakpoints.up("md")]: {
      top: isSafari ? 24 : 0,
      right: 70,
    },
  },
}));

interface QuestionSectionWrapperProps {
  classes: any;
  onUpdate: any;
  style: any;
}

const AnswerSectionWrapper = (props: QuestionSectionWrapperProps) => (
  <BorderSectionWrapper fullHeight>
    <Box className={props.classes.favourite} onClick={props.onUpdate} style={props.style}>
      <FavoritesIcon style={{ cursor: "pointer" }} />
    </Box>
    <AnswerSection />
  </BorderSectionWrapper>
);

interface IAnswerContainerProps {
  activeSubcategory: MenuItemSubcategory;
  activeCategory: MenuItemCategory;
  refetchIsFavourite: (category?: string, subcategory?: string, index?: number) => void;
  isFavourite: boolean;
  onUpdateUserFavourite: (category?: string, subcategory?: string, index?: number) => void;
}

export const AnswerContainer: React.VFC<IAnswerContainerProps> = (props) => {
  const { activeSubcategory, activeCategory, isFavourite, onUpdateUserFavourite, refetchIsFavourite } = props;
  const { activeAnswerIndex } = useContext(AnswerContext);
  const classes = useStyles();
  const currentSubcategory = useMemo(() => MenuSubcategoryDictionary[activeSubcategory], [activeSubcategory]);
  const { color } = MenuCategoryDictionary[activeCategory];
  const backgroundColor = useMemo(() => (isFavourite && color ? color : theme.palette.grey[100]), [isFavourite, color]);

  const transitionsProps = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  });

  useEffect(() => {
    refetchIsFavourite(activeCategory, activeSubcategory, activeAnswerIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeAnswerIndex]);

  return (
    <Grid item container>
      <Grid container direction="column" className={classes.mainSection}>
        {currentSubcategory.isQuestionBased && (
          <animated.div style={transitionsProps} className={classes.mainSectionItem} key="answer-wrapper">
            <AnswerSectionWrapper
              classes={classes}
              onUpdate={() => onUpdateUserFavourite(activeCategory, activeSubcategory, activeAnswerIndex)}
              style={{ backgroundColor: backgroundColor }}
            />
          </animated.div>
        )}
      </Grid>
    </Grid>
  );
};
